import { useMemo, useState } from "react";
import * as React from "react";
import { AuditSession } from "../models/heretic/auditSession";
import { Combobox, Option } from "@fluentui/react-components";

interface SessionFileSearchProps {
  session: AuditSession;
  onSelectedFileChange: (fileId: string) => void;
  currentFileDocumentId: string;
}

export const SessionFileSearch: React.FC<SessionFileSearchProps> = ({
  session,
  onSelectedFileChange,
  currentFileDocumentId,
}) => {
  const documents = useMemo(() => session.documents, [session]);
  const [searchValue, setSearchValue] = useState("");

  const filteredDocuments = useMemo(() => {
    if (!searchValue) return documents;
    return documents.filter((doc) => doc.name.toLowerCase().includes(searchValue.toLowerCase()));
  }, [documents, searchValue]);

  const selectedDocument = useMemo(() => {
    return documents.find((doc) => doc.documentId === currentFileDocumentId);
  }, [documents, currentFileDocumentId]);

  return (
    <div>
      <Combobox
        placeholder="Search files..."
        onOptionSelect={(_, data) => {
          const selectedDoc = documents.find((doc) => doc.documentId === data.optionValue);
          if (selectedDoc) {
            onSelectedFileChange(selectedDoc.documentId);
          }
        }}
        onChange={(e) => setSearchValue(e.target.value)}
        value={selectedDocument?.name || ""}
        selectedOptions={selectedDocument ? [selectedDocument.documentId] : []}
      >
        {filteredDocuments.map((document) => (
          <Option key={document.documentId} value={document.documentId}>
            {document.name}
          </Option>
        ))}
      </Combobox>
    </div>
  );
};
